// extracted by mini-css-extract-plugin
export var container = "index-module--container--23Id-";
export var wrap = "index-module--wrap--9A-WK";
export var storyItems = "index-module--storyItems--80zgP";
export var storyItem = "index-module--storyItem--1A1So";
export var children = "index-module--children--HsctJ";
export var slideUp = "index-module--slideUp--xBjLX";
export var slideUpLarge = "index-module--slideUpLarge--inNCJ";